import DayParts from './components/DayParts.vue'

export default DayParts



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/dayParts/index.js